<template>
  <div :class="['dropbox', maxNum > 1 ? 'paddingDropbox' : '']">
    <div :class="['dropbox-background', !canDrop ? 'remove-drop' : '', maxNum > 1 ? 'paddingDropbox' : '', hovering ? 'hover' : '']"
      style="min-width: 100%"
      :style="maxNum > 1 ? {width: (value.length * 160 + 60)+'px'} : {}"
      @mouseover="mouseOver" @mouseout="mouseOut" @dragover.stop="dragOver" @dragleave="dragLeave"
    >
      <input
        type="file"
        :multiple="maxNum > 1"
        :name="uploadFieldName"
        :disabled="!canDrop"
        @change="filesChange($event.target.name, $event.target.files); $event.target.value = ''"
        @drop.stop
        :class="['input-file', !canDrop ? 'remove-drop' : '']"
        :style="{ height: '100%' }"
        :accept="accept"
      >
    </div>
    <v-flex v-if="value.length === 0" class="dropbox-message">
      <v-icon style="font-size:50px">attach_file</v-icon>
      <div>{{maxNum > 1 ? $t('general.fileUploader.dragMulti') : $t('general.fileUploader.drag')}}</div>
    </v-flex>
    <draggable
      v-if="value.length > 0"
      v-model="uploadedFilesComputed"
      class="image-list"
      :disabled="maxNum === 1 || value.length < 2 || disabled"
      :forceFallback="true"
      :preventOnFilter="true"
      filter=".no-draggable"
      @start="onStart"
      @end="onEnd"
      >
      <div
        v-for="(item, index) in value" :key="item.id ? item.id : item.id_temporal"
        :class="['image-list-item', maxNum > 1 && value.length > 1 && !disabled ? 'draggable' : 'noDrag', dragging ? 'hide-remove' : '']"
      >
        <FilePreview
          :class="['image-list-image', value.length < 2 ? 'noDrag' : '']"
          :file="item"
          @remove="remove(index)"
          :deletable="deletable"
          :contrato="contrato"
          :interactable="interactable"
          @ampliar="mostrarImagenAmpliada(index)"
        ></FilePreview>
      </div>
    </draggable>
    <custom-dialog v-if="mostrarImagen" v-model="mostrarImagen" :subPopUp="subPopUp">
      <v-container>
        <v-layout justify-center>
        <v-img 
          class="fullScreenCarousel"
          :src="value[index].id ? $apiDocument(value[index]) : value[index].documentoGrande"
          contain
        />
        </v-layout>
      </v-container>
    </custom-dialog>
  </div>
</template>
<script>
  import { upload } from './filePreviewUpload.js'
  import FilePreview from './FilePreview'
  import uniqid from 'uniqid'
  import draggable from 'vuedraggable'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      FilePreview,
      draggable
    },
    props: {
      contrato: {
        default: false,
        type: Boolean
      },
      maxNum: {
        default: 1,
        type: Number
      },
      uploadFieldName: {
        default: 'image',
        type: String
      },
      value: {
        type: Array
      },
      deletable: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      interactable: {
        type: Boolean,
        default: true
      },
      accept: {
        type: String,
        default: ''
      },
      imagesOnly: {
        type: Boolean,
        default: false
      },
      subPopUp: {
        type: Boolean,
        default: false
      },
      maxNameLength: {
        type: Number,
        default: 100
      },
      minFileSize: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        dragging: false,
        hovering: false,
        index: 0,
        mostrarImagen: false
      }
    },
    computed: {
      ...mapGetters({
        maxFileSize: 'constantes/getMaxFileSize'
      }),
      canDrop () {
        return !this.disabled && (!this.dragging && this.maxNum > this.value.length)
      },
      uploadedFilesComputed: {
        get () {
          return this.value
        },
        set (newVal) {
          this.$emit('input', newVal)
        }
      }
    },
    methods: {
      ...mapActions({
        addAlert: 'alerts/add'
      }),
      mostrarImagenAmpliada (index) {
        this.index = index
        this.mostrarImagen = true
      },
      reset () {
        // reset form to initial state
        this.$emit('input', [])
      },
      remove (index) {
        const newVal = this.value
        newVal.splice(index, 1)
        this.$emit('input', newVal)
      },
      save (formData, file) {
        // upload data to the server
        upload(formData)
          .then(x => {
            if (this.imagesOnly && x[0].mime != null && !x[0].mime.startsWith('image')) {
              this.addAlert({texto: this.$t('general.fileUploader.alertaImg'), color: 'error'})
            } else if (x[0].nombre != null && x[0].nombre.length > this.maxNameLength) {
              this.addAlert({texto: this.$t('general.fileUploader.alertaNombre'), color: 'error'})
            }  else if (x[0].tamanio > ((this.maxFileSize + 1024))) {
              this.addAlert({texto: 'El tamaño del archivo no puede superar los ' + this.maxFileSize + ' bytes.', color: 'error'})
            } else if (x[0].tamanio < this.minFileSize) {
              this.addAlert({texto: this.$t('general.fileUploader.alertaVacio'), color: 'error'})
            } else if (x[0].extension.length > 4) {
              this.addAlert({texto: this.$t('general.fileUploader.alertaTipo'), color: 'error'})
            } else {
              const newFile = {
                id_temporal: uniqid(),
                status: 'SAVING',
                file: file,
                error: ''
              }
              newFile.nombre = x[0].nombre
              newFile.mime = x[0].mime
              newFile.documentoGrande = x[0].documentoGrande
              newFile.extension = x[0].extension
              newFile.status = 'SUCCESS'
              let newVal = this.value
              newVal.push(newFile)
              this.$emit('input', newVal)
            }
          })
          .catch(err => {
            this.addAlert({texto: err.message, color: 'error'})
            // newFile.error = err.message
            // newFile.status = 'FAILED'
            // this.$emit('input', newVal)
          })
      },
      filesChange (fieldName, fileList) {
        // handle file changes
        const filesToUpload = Math.min(fileList.length, this.maxNum - this.value.length)
        if (!fileList.length || filesToUpload <= 0) {
          return
        }
        for (let i = 0; i < filesToUpload; i++) {
          let formData = new FormData()
          formData.append(fieldName, fileList[i], fileList[i].name)
          this.save(formData, fileList[i])
        }
      },
      onStart () {
        this.dragging = true
      },
      onEnd () {
        this.dragging = false
      },
      mouseOver () {
        if (!this.dragging) {
          this.hovering = true
        }
      },
      mouseOut () {
        this.hovering = false
      },
      dragOver () {
        if (!this.dragging) {
          this.hovering = true
        }
      },
      dragLeave () {
        this.hovering = false
      }
    },
    beforeDestroy () {
    }
  }
</script>

<style lang="stylus" scoped>

  .paddingDropbox.dropbox
    overflow-y: auto

  .dropbox
    position relative
    border: 2px solid #e5e5e5
    border-radius: 2px;
    padding 5px 5px
    display flex
    justify-content center
    align-items center
    flex-grow 1

  .dropbox-background
    position absolute
    top 0
    left 0
    min-height 100%
    width 100%
    height 100%
    background-color white
    background-repeat repeat
    background-position-x 20.5px
    background-position-y 10.25px
    &.hover:not(.remove-drop)
      background-size 30px 30px
      background-image linear-gradient(-45deg,#F6F6F6 25%,transparent 26%,transparent 50%,#F6F6F6 50%,#F6F6F6 75%,transparent 76%,transparent)
      animation stripes 2s linear infinite
      @keyframes stripes {
        from { background-position: 0 0; }
        to   { background-position: 60px 30px; }
      }

  .input-file
    opacity 0
    width 100%
    height 100%
    max-height inherit
    &:not(.remove-drop)
      cursor pointer

  .dropbox .dropbox-message
    margin 10px
    font-size 14px
    text-align center
    justify-content center
    align-items center
    z-index: 1
    pointer-events none

  .image-list
    pointer-events none
    vertical-align: middle
    position absolute
    z-index 2
    left 0
    top 0
    width 100%
    height 100%
    padding-left 20px
    padding-right 20px
    padding-top 15px
    padding-bottom 15px
    display flex
    flex-direction row
    &.noDrag
      pointer-events none


  .image-list-item
    pointer-events visible
    display flex
    align-items center
    flex-grow 0
    margin 5px
    user-select none
    width:150px
    max-width: 100%
    &.noDrag
      pointer-events none
    &.noDrag .image-list-image
      pointer-events visible

  .image-list-image
    display flex
    align-items center
    justify-content center
    width:200px
    height 100%
    position relative
    background-color: white;
    outline: 1px solid #e5e5e5
    flex-wrap: wrap


  .draggable:hover
    cursor move

  .fullScreenCarousel
    width:80vw;
    height:80vh;
    pointer-events: none;

</style>






// WEBPACK FOOTER //
// src/components/generic/fileUploader/FileUploader.vue